
import React, { useEffect, useMemo, useState } from 'react'
import moment from 'moment'

import { useDatePicker } from '@/Hooks/UseDatePicker'
import { useProject } from '@/Hooks/UseProject'
import useTranslation from '@/Hooks/UseTranslation'

import Calendar from '@/Components/SvgImages/Calendar'
import Times from '@/Components/SvgImages/Times'

import './NonWorkingDay.scss'

interface Props {
  value: string
  onChange: (value: string) => void
  onRemove?: () => void
  disabled?: boolean
}

const NonWorkingDay = ({ value, onChange, onRemove, disabled }: Props) => {

  const { showDatePicker } = useDatePicker()

  const { project, nonWorkingDays } = useProject()

  const [ date, setDate ] = useState('')

  useEffect(() => {

    if (!value) {

      const today = moment()

      if (today.isBefore(project.startsAt)) {

        setDate(project.startsAt)
      } else if (today.isAfter(project.endsAt)) {

        setDate(project.endsAt)
      } else {

        setDate(today.format('YYYY-MM-DD'))
      }
    }

    if (value) {

      setDate(moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD'))
    }
  }, [value])

  const handleChangeDate = async (date: string) => {

    onChange(date)
  }

  const handleShowDatePicker = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    if (disabled) return

    showDatePicker({
      date,
      projectStartDate: project.startsAt,
      projectEndDate: project.endsAt,
      nonWorkingDays,
      onChange: handleChangeDate
    })
  }

  const handleRemove = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    if (disabled) return

    onRemove && onRemove()
  }

  return (
    <div className={`non-working-day ${disabled ? 'disabled' : ''}`}
      onClick={handleShowDatePicker}
    >
      {value && (
        <div className="day-name">
          {value && moment(value, 'YYYY-MM-DD').format('dddd')}
        </div>
      )}
      <div className="day-date">
        {!value && 'dd/mm/yyyy'}
        {value && moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')}
      </div>
      <div className='day-actions'>
        <div className="action-edit">
          <button
            className=""
            onClick={handleShowDatePicker}
            disabled={disabled}
          >
            <Calendar height={14} width={14} fill={disabled ? '#ccc' : '#000'} />
          </button>
        </div>
        <div className="action-remove">
          <button
            className=""
            onClick={handleRemove}
            disabled={disabled}
          >
            <Times height={20} width={20} fill={disabled ? '#ccc' : '#000'} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default NonWorkingDay
